import { AfterViewInit, Directive, Input } from '@angular/core';

import { TrackingModel, TrackingModelService } from '@frontend/promo-homewidget';

@Directive({
    selector: '[onLoadWebTracker]',
    standalone: true,
})
export class OnLoadWTDirective implements AfterViewInit {
    @Input('onLoadWebTracker') option: TrackingModel;
    constructor(private trackingService: TrackingModelService) {}

    ngAfterViewInit() {
        this.trackingService.submitTracking(this.option, 'contentView');
    }
}
